<template>
  <span class="badge">
    <vs-chip class="pt-0 pb-0 pr-2 pl-2" :color="context" v-text="content"></vs-chip>
  </span>
</template>

<script>
export default {
  name: 'BadgePriority',
  props: {
    content: {
      type: String,
      required: true
    },
    status: {
      type: Number,
      required: true
    }
  },
  computed: {
    context () {
      switch (this.status) {
      case 1:
        return 'primary'
      case 2:
        return 'warning'
      case 3:
        return 'danger'
      default:
        return ''
      }
    }
  }
}
</script>

<style lang="scss">

</style>
